/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
const redirecturi = process.env.REACT_APP_REDIRECT_URI;

export const msalConfig = {
	auth: {
		clientId: "033cc344-5269-4186-90ac-4cc5876a276c",
		authority:
			"https://login.microsoftonline.com/ece02ed1-e934-4e62-97cd-035e12f17117",
		redirectUri: redirecturi,
		postLogoutRedirectUri: "/",
	},
	cache: {
		cacheLocation: "sessionStorage", // This configures where your cache will be stored
		storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
	},
	system: {
		loggerOptions: {
			loggerCallback: (level: any, message: any, containsPii: any) => {
				if (containsPii) {
					return;
				}
				switch (level) {
					case LogLevel.Error:
						// console.error(message);
						return;
					case LogLevel.Info:
						// console.info(message);
						return;
					case LogLevel.Verbose:
						// console.debug(message);
						return;
					case LogLevel.Warning:
						// console.warn(message);
						return;
					default:
						return;
				}
			},
		},
	},
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
	scopes: ["User.Read", "User.Read.All"],
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const getProfile = {
	graphMeEndpoint:
		"https://graph.microsoft.com/v1.0/me?$select=department,userPrincipalName,jobTitle,displayName,businessPhones,mobilePhone,country,onPremisesDomainName,city,officeLocation", //e.g. https://graph.microsoft.com/v1.0/me
};

export const getPhoto = {
	graphMeEndpoint: "https://graph.microsoft.com/v1.0/me/photo/$value", //e.g. https://graph.microsoft.com/v1.0/me
};

export const getManager = {
	graphMeEndpoint: "https://graph.microsoft.com/v1.0/me/manager", //e.g. https://graph.microsoft.com/v1.0/me
};
